import styles from '../../styles/mainContent/Home.module.css';
import utilities from '../../styles/utilities.module.css';
import ResumeDownload from './ResumeDownload';

const Home = () => {
  return (
    <section id="home" className={utilities.container}>
      <h1 className={styles.title}>Benjamin Gregory</h1>
        <div className={styles.subsection}>
          <h2>About Me</h2>
          <p className={styles.introText}>
          Hi! I have B.S. in Computer Science with a minor in Data Science from Lafayette College with an interest in puzzle solving, math, and linguistics. My career experience includes embedded system and machine learning infrastructure, using a wide range of tools and frameworks. In addition to my passion for software engineering, my interests include cooking, crafting, and good stories. I take an equally analytical, creative, and curious perspective to all my pursuits and hobbies, where every challenge becomes a meaningful, intellectual pursuit.
          </p>
          <ResumeDownload />
        </div>
    </section>
  );
};

export default Home;